import React, { useState } from "react";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";
import awlLogo from './awl-logo.png'; 

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      if (email === "test@awl.in" && password === "password123") {
        onLogin();
      } else {
        alert("Invalid credentials (hint: test@awl.in / password123)");
      }
    }, 600);
  };

  return (
    <div className="login-viewport">
      <div className="bg-decor">
        <div className="drop d1" />
        <div className="drop d2" />
        <div className="drop d3" />
        <div className="drop d4" />
        <div className="drop d5" />
      </div>

      <div className="login-wrapper" role="main" aria-labelledby="signin-heading">
        <div className="brand-section">
          <h1 id="signin-heading" className="app-title">
            AWL<span className="app-title-highlight">ONE</span>
          </h1>
          <p className="app-subtext">Capture & analyze market insights for a smarter business.</p>
        </div>

        <form className="login-card" onSubmit={handleSubmit} noValidate>
          <div className="input-group">
            <label htmlFor="email" className="sr-only">Email address</label>
            <div className="input-with-icon">
              <FontAwesomeIcon icon={faEnvelope} className="input-icon" />
              <input
                id="email"
                type="email"
                placeholder="Enter your mail ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="login-input"
                required
              />
            </div>
          </div>

          <div className="input-group">
            <label htmlFor="password" className="sr-only">Password</label>
            <div className="input-with-icon">
              <FontAwesomeIcon icon={faLock} className="input-icon" />
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="login-input"
                required
              />
              <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.06 13.06a12.55 12.55 0 0 1 1.63-2.14C6.27 7.21 9.4 5 12 5c2.6 0 5.73 2.21 8.31 5.92a12.55 12.55 0 0 1 1.63 2.14M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                )}
              </span>
            </div>
          </div>

          <div className="forgot-password-row">
            <button type="button" className="forgot-password-link">
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            className={`login-btn ${loading ? "loading" : ""}`}
            disabled={loading}
          >
            {!loading ? "Sign in" : "Signing in..."}
          </button>
        </form>

        <div className="company-logo-wrapper">
          <img src={awlLogo} alt="AWL Agri Business Logo" className="company-logo" />
        </div>
      </div>
    </div>
  );
}